// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mb-0";
export var assigneeDetails = "_mb-1";
export var assigneeInfo = "_mb-2";
export var dropdownContainer = "_mb-4";
export var dropdownImage = "_mb-5";
export var editAssigneeInfo = "_mb-3";
export var editAssigneeModalContainer = "_mb-6";
export var hidden = "_mb-8";
export var input = "_mb-7";